<template>
	<div>
		<div
			class="mob-back-header d-flex align-items-center justify-content-between"
			v-if="isNative"
		>
			<div class="d-flex align-items-center">
				<img
					class="mr-2"
					src="../../assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
					@click="$router.push({ name: 'ApplicationResult' })"
				/>

				<span>Candidate Verification & Screening</span>
			</div>
		</div>
		<header class="cvs-header" v-else>
			<div class="d-flex align-items-center gap-2">
				<img
					src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg"
					alt=""
				/>
				<div class="cvs-vertical-line"></div>
				<span class="cvs-black-txt">Candidate Verification & Screening</span>
			</div>
		</header>
		<b-container class="cvs-container">
			<main class="cvs-image-cont">
				<main
					class="h-100 w-100 d-flex align-items-center justify-content-center"
				>
					<article class="cvr-done-verification">
						<h1 class="mt-4 pt-2">Submitted Successfully</h1>
						<img src="../../assets/newdesign/cvs/submittedSuces.svg" alt="" />
						<h3 class="mt-4" v-if="$route.query.type == 'submitted'">
							Your verification has been submitted successfully.
						</h3>
						<h3 class="mt-4" v-else>
							Your verification has already been submitted.
						</h3>
						<h4 class="mt-2">
							You have successfully completed your verification. You can now log
							in to Hire3x to check your job progress.
						</h4>
						<b-button class="candash-addBtn mt-4" @click="goToHire3x()"
							>Go to Hire3x</b-button
						>
						<span class="mt-4 mb-2">Follow Us</span>
						<section class="cvr-footer">
							<a
								href="https://www.instagram.com/hire3x?igsh=MWQ0bzhqandjenprYg=="
								id="insta"
								target="_blank"
							>
								<img
									src="../../assets/icons/candidatedashboard/canddashright/Instagram.svg"
									alt=""
								/>
							</a>
							<a
								href="https://www.facebook.com/profile.php?id=61552725574787&mibextid=AEUHqQ"
								id="fb"
								target="_blank"
							>
								<img
									src="../../assets/icons/candidatedashboard/canddashright/Facebook.svg"
									alt=""
								/>
							</a>
							<a
								href="https://www.twitter.com/hire3x/"
								id="twitter"
								target="_blank"
							>
								<img
									src="../../assets/icons/candidatedashboard/canddashright/twitter.svg"
									alt=""
								/>
							</a>
							<a
								href="https://www.linkedin.com/company/hire3x/"
								id="linkedin"
								target="_blank"
							>
								<img
									src="../../assets/icons/candidatedashboard/canddashright/Linkedin.svg"
									alt=""
								/>
							</a>
						</section>
					</article>
				</main>
			</main>
		</b-container>
	</div>
</template>
<script>
import "@/assets/globalcss/cvs.css";
import { Capacitor } from "@capacitor/core";
import { config } from "@/config";

export default {
	data() {
		return {
			isNative: false,
			config,
		};
	},
	created() {
		this.isNative = Capacitor.isNativePlatform();
	},
	methods: {
		goToHire3x() {
			window.open(this.config.websiteBase);
		},
	},
};
</script>
